<template>
  <div class="flex h-screen flex-row overflow-hidden">
    <div class="w-full desktop:pt-8 flex flex-col h-full min-h-0">
      <Header class="hidden desktop:flex desktop:pl-6 desktop:pr-10 flex-shrink-0" />
      <MobileHeader class="desktop:hidden desktop:pl-6 desktop:pr-10 flex-shrink-0" />
      <div class="flex-1 min-h-0 flex flex-col">
        <main class="flex-1 min-h-0 overflow-y-auto">
          <div class="desktop:pl-6 desktop:pr-10">
            <slot />
          </div>
          <Footer class="flex-shrink-0" />
        </main>
      </div>
      <MobileStickyFooter />
    </div>
  </div>
</template>

<script setup lang="ts">
import MobileStickyFooter from '@/components/MobileStickyFooter.vue'
import Footer from '@/components/Footer.vue'
</script>

<style scoped></style>
